export const generateDeviceId = async (userId: number, userAgent: string) => {
  const rawString = `${userAgent}-${userId}`

  const encoder = new TextEncoder()
  const data = encoder.encode(rawString)

  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
}
